module.exports = __webpack_public_path__ + "static/media/telefonia.eff64b57.gif";